import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { userLogin } from "../../Services/api";
import { toast } from 'react-toastify';
import NodeaxiosInstance from "../../Services/nodeaxios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"
const ChangePassword = () => {
    const [isLoading, setLoadingStatus] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const location = useLocation();
    const [password, setPassword] = useState()
    const [confirmpassword, setConfirmPassword] = useState()
    const [showPassword, setShowPassword] = useState(false);
    const [showconfirmpassword, setShowConfirmpassword] = useState(false)
    const [errors, setErrors] = useState({})


    useEffect(() => {

        if (password != confirmpassword) {
            setErrors('Passwords do not match')
        }
    }, [confirmpassword]);

    const updatedPassword = () => {
        setPhoneNumberError('');
        if (!password || !confirmpassword) {
            toast("Please enter password and confirm password", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: true,
                theme: "light",
                className: 'text-danger toast-style-1'
            });
            return;
        }
        const validation = validatePasswords(password, confirmpassword);
        setErrors(validation);

        if (validation.password || validation.confirmpassword) return;


        setLoadingStatus(true);

        const param = {
            inputType: location?.state?.inputType,
            inputValue: location?.state?.inputValue,
            newPassword: confirmpassword
        };

        NodeaxiosInstance.post('auth/forgot-password/reset', param)
            .then((res) => {
                if (res.data.status == "1") {
                    if (location?.state?.flow == 'emailverify') {
                        navigate('/');
                    }
                    else {
                        navigate('/login', { state: { fromGuest: true } })
                    }
                }
            })
            .catch(error => {
                toast(error?.response?.data?.message || "Something went wrong", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
            })
            .finally(() => setLoadingStatus(false));
    };

    const validatePasswords = (password, confirmPassword) => {
        const errors = {
            password: "",
            confirmpassword: "",
        };

        if (!password) {
            errors.password = "";
        } else if (password.length < 8) {
            errors.password = "Minimum 8 characters";
        } else if (!/[A-Z]/.test(password)) {
            errors.password = "Must contain uppercase";
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
            errors.password = "Must contain special character";
        }

        if (!confirmPassword) {
            errors.confirmpassword = "";
        } else if (confirmPassword.length >= 8 && password !== confirmPassword) {
            errors.confirmpassword = "Passwords do not match";
        }

        return errors;
    };

    const checkBtnDisable = () => {
        if (!password || !confirmpassword) {
            return true;
        }
        if (password != confirmpassword) {
            return true;
        }
        if (errors.password || errors.confirmpassword) {
            return true;
        }
        return false;

    }

    return (
        <>  <div className=" bg-white ">
            <div className="position-relative">
                <img src={topBanaer} height="110px" width="100%" />
                <img src={UserLogo} height="80px" width="80px" className="rounded-3 position-absolute top-100 start-50 translate-middle  mb-2 " />
            </div>
            <div className="loginPage loginFlow py-3 bg-white vh-100 d-flex align-items-center">
                <div className="w-100 ">
                    <div className="ff-poppins-bold fs-24 ">Change Password</div>
                    <p className="mb-3 p-0 m-0 ff-poppins-medium fs-12 primary-text">Your new password must be different from<br /> previous password</p>

                    <div className="ff-poppins-medium mt-3">
                        <label className="fs-15">Password</label>
                        <div style={{ position: "relative" }}>
                            <input type={showPassword ? "text" : "password"}
                                className="form-control rounded-0 border-0  fs-20 secondary-text no-spinners w-100 ff-poppins-medium"
                                name="password" placeholder="Enter the password"
                                maxLength={20} value={password}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    if (input.length > 20) return;
                                    setPassword(input);
                                    const validation = validatePasswords(input, confirmpassword);
                                    setErrors(validation);
                                }} />

                            <span onClick={() => setShowPassword(!showPassword)}
                                style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}  >
                                {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                            </span>
                        </div>
                        {errors.password && (
                            <div className="text-danger fs-10 mt-1">{errors.password}</div>
                        )}
                    </div>

                    <div className="ff-poppins-medium mt-3">

                        <label className="fs-15">Confirm Password</label>

                        <div style={{ position: "relative" }}>
                            <input type={showconfirmpassword ? "text" : "password"}
                                className="form-control rounded-0 border-0  fs-20 secondary-text no-spinners w-100 ff-poppins-medium"
                                name="password" placeholder="Enter the confirm password"
                                maxLength={45} value={confirmpassword}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    if (input.length > 20) return;

                                    setConfirmPassword(input);

                                    const validation = validatePasswords(password, input);
                                    setErrors(validation);
                                }}
                            />

                            <span onClick={() => setShowConfirmpassword(!showconfirmpassword)}
                                style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}  >
                                {showconfirmpassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                            </span>
                        </div>
                        {errors.confirmpassword && (
                            <div className="text-danger fs-10 mt-1">{errors.confirmpassword}</div>
                        )}
                    </div>

                    <div className="d-flex justify-content-center">
                        <button type="submit" onClick={updatedPassword} disabled={checkBtnDisable()}
                            className={`${isLoading ? "loading" : ""}  ${checkBtnDisable() ? "opacity-40" : ""} primary-bg  w-100 border-0 rounded-pill ff-poppins-semiBold fs-20 text-white mt-5 d-flex justify-content-center align-items-center`}>
                            {isLoading ? <span className="loader-style-1"></span> : <span>Change</span>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
};

export default ChangePassword;